import React from "react";
import Help from "./Help";
import View from "common/View";
import StatsLatencyReport from "./Report";

const StatsLatency = () => (
  <View title="Latency Over Time" Help={Help}>
    <StatsLatencyReport />
  </View>
);

export default StatsLatency;
